"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeptGroupRow = KeptGroupRow;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("../..");
const Table_1 = require("..");
const Css_1 = require("../../../Css");
const hooks_1 = require("../../../hooks");
const utils_1 = require("../../../utils");
function KeptGroupRow(props) {
    const { as, columnSizes, style, row, colSpan } = props;
    const CellTag = as === "table" ? "td" : "div";
    const { tableState } = (0, react_1.useContext)(Table_1.TableStateContext);
    const numHiddenSelectedRows = (0, hooks_1.useComputed)(() => tableState.keptRows.length, [tableState]);
    return ((0, jsx_runtime_1.jsx)(CellTag, { css: {
            ...style.cellCss,
            ...style.keptGroupRowCss,
            ...Css_1.Css.pl0.w(`calc(${columnSizes.join(" + ")})`).$,
        }, ...(as === "table" ? { colSpan } : {}), children: (0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.aic.gapPx(12).$, children: [(0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.wPx(38).df.jcc.$, children: (0, jsx_runtime_1.jsx)(Table_1.CollapseToggle, { row: row, compact: true }) }), (0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.aic.gap1.$, children: [(0, jsx_runtime_1.jsx)(components_1.Icon, { icon: "infoCircle", inc: 2 }), `${numHiddenSelectedRows} selected ${(0, utils_1.pluralize)(numHiddenSelectedRows, "row")} hidden due to filters`] })] }) }));
}
